import { render, staticRenderFns } from "./UploadIconButton.vue?vue&type=template&id=3af0661f&lang=pug&"
import script from "./UploadIconButton.vue?vue&type=script&lang=ts&"
export * from "./UploadIconButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UploadIconButton.vue"
export default component.exports